import React from 'react';
import {useTranslation} from 'react-i18next';
import {
    IconFaceValidationSelfie,
    IconPhotoTake
} from '../../../../components/buttons/IconButtons';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const FaceValidation = ({ guardFlowId }) => {
    const { t } = useTranslation();

    return (
        <>
            <div className="d-flex flex-column">
                <p className="fs-24-to-18 ibl-font-w-600 font-color-general-950 text-center">{t("face_validation")}</p>
                <p className="fs-20-to-14 ibl-font-w-400 font-color-general-950 text-center">
                    { guardFlowId ?
                        t("take_a_clear_photo_of_visitor_to_continue")
                        :
                        t("take_a_photo_for_yourself")
                    }
                </p>
            </div>

            <div className="d-flex justify-content-center align-items-center">
                <div className="icon-face-validation-selfie">
                    <IconFaceValidationSelfie className={"h-100 w-100"} />
                </div>
            </div>


            <div className="d-none d-md-block p-0 m-0">
                <div className="d-flex justify-content-center align-items-center gap-8px">
                    <IconPhotoTake />
                    <p className="ibl-ientry-p ibl-font-w-600 font-color-general-950">{t("photo_tips")}</p>
                </div>
            </div>

            <div className="d-none d-md-block">
                <p className="fs-14-to-13 ibl-font-w-400 font-color-general-950 text-center">
                    {`• ${t("face_should_be_fully_visible_centered_and_looking_at_the_camera")}`}<br />
                    {`• ${t("use_a_plain_background_preferably_white_or_light_colored")}`}<br />
                    {`• ${t("take_the_photo_in_a_well_lit_environment_avoid_backlight_or_shadows")}`}<br />
                    {`• ${t(guardFlowId ? "make_sure_the_visitor_is_not_wearing_glasses_masks_or_hats" : "remove_glasses_masks_or_hats")}`}<br />
                    {`• ${t("dont_use_filters_or_effects")}`}<br />
                    {`• ${t( guardFlowId ? "ask_visitor_to_maintain_neutral_expression" : "keep_a_neutral_expression_or_slight_smile")}`}
                </p>
            </div>
        </>
    )

}

export default FaceValidation
